import * as Platform from '../Platform/Platform.js'

const assetDir = Platform.getAssetDir()

export const Add = `${assetDir}/icons/add.svg`
export const Close = `${assetDir}/icons/icon-close.svg`
export const DebugAlt2 = `${assetDir}/icons/debug-alt-2.svg`
export const Discard = `${assetDir}/icons/discard.svg`
export const Ellipsis = `${assetDir}/icons/ellipsis.svg`
export const ExtensionDefaultIcon = `${assetDir}/icons/extensionDefaultIcon.png`
export const ExtensionLanguageBasics = `${assetDir}/icons/language-icon.svg`
export const Extensions = `${assetDir}/icons/extensions.svg`
export const ExtensionTheme = `${assetDir}/icons/theme-icon.png`
export const Files = `${assetDir}/icons/files.svg`
export const NextMatch = `${assetDir}/icons/arrow-down.svg`
export const PreviousMatch = `${assetDir}/icons/arrow-up.svg`
export const Search = `${assetDir}/icons/search.svg`
export const SettingsGear = `${assetDir}/icons/settings-gear.svg`
export const SourceControl = `${assetDir}/icons/source-control.svg`
export const SymbolDefault = 'IconDefault'
export const SymbolFunction = `${assetDir}/icons/symbol-method.svg`
export const SymbolKeyword = `${assetDir}/icons/symbol-keyword.svg`
export const SymbolProperty = `${assetDir}/icons/symbol-property.svg`
export const SymbolValue = `${assetDir}/icons/symbol-enum.svg`
export const SymbolVariable = `${assetDir}/icons/symbol-variable.svg`
export const GoToFile = `${assetDir}/icons/go-to-file.svg`
export const Blank = `${assetDir}/icons/blank.svg`
